
















































































































































































































































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import { classroomList } from '@/api/teachingProtection/teachManage'
import {
  disinfectCheckStatic,
  disinfectCheckExport,
  disinfectCheckInfo
} from '@/api/teachingProtection/childCare'
interface Row {
  comeGardenPrepareAbnormalList: [],

}
@Component({
  name: 'static',
  components: {
    Chart
  },
  filters: {
    infoFilter(optionType:any, arr:any) {
      let str = ''
      arr.map((item:any) => {
        if (item.optionType === optionType) {
          str = item.description
        }
      })
      return str
    }
  }
})
export default class extends Vue {
  private staticTime: (string | number)[] = [
    Date.now() - 6 * 24 * 60 * 60 * 1000,
    Date.now()
  ]; // 统计时间
  private recordTime: (string | number)[] = [Date.now(), Date.now()]; // 记录时间
  private staticForm: any = {
    fromInspectTime: Date.now(),
    toInspectTime: Date.now()
  };
  private recordForm: any = {
    fromInspectTime: Date.now(),
    toInspectTime: Date.now(),
    classroomId: '',
    hadRecheck: '',
    hadCheck: '',
    recheckQua: ''
  };
  private checkStatus: any = [
    { code: 1, description: '已检查' },
    { code: 0, description: '未检查' }
  ];
  private classList: any = []; // 班级
  private checkList: any = [1]; // 班级
  private infoVisible: boolean = false;
  private infoTitle: string = '记录详情';
  private recordInfo: any = {}; // 记录详情
  private curRowData: any = {}; // 当前学生信息
   private initialData: any = [
     {
       title: '来园准备',
       timeStr: '8:30-9:00',
       children: [
         {
           code: 0,
           optionType: 101101,
           description: '开窗通风，消毒餐具、餐巾、杯子。'
         },
         {
           code: 0,
           optionType: 101102,
           description:
            '用消毒水擦拭杯格、玩具柜、水笼头等幼儿易接触到的物体表面。'
         },
         {
           code: 0,
           optionType: 101103,
           description: '打扫室内卫生，擦灰尘、整理物品。'
         }
       ]
     },
     {
       title: '点心及打扫',
       timeStr: '9:00-10:00',
       children: [
         {
           code: 0,
           optionType: 102101,
           description: '点心前的桌面消毒。'
         },
         {
           code: 0,
           optionType: 102102,
           description: '餐后打扫，保证桌面及地面清洁。'
         },
         {
           code: 0,
           optionType: 102103,
           description: '消毒餐盘、餐巾及擦桌毛巾。'
         },
         {
           code: 0,
           optionType: 102104,
           description: '消毒擦拭窗台、门把手，冲刷消毒洗手池、便池、墩布池。'
         }
       ]
     },
     {
       title: '公共区域、午餐、午睡准备',
       timeStr: '10:00-12:30',
       children: [
         {
           code: 0,
           optionType: 103101,
           description: '公共区域卫生的打扫。'
         },
         {
           code: 0,
           optionType: 103102,
           description:
            '午餐前的桌面消毒清洗。餐后消毒餐盘、餐巾、擦桌毛巾、餐具等物品，收拾餐具，清理桌面，扫、拖地面（包括厕所地面）清洁地面。'
         },
         {
           code: 0,
           optionType: 103103,
           description: '擦拭消毒水龙头，冲刷消毒洗手池、便池、墩布池。'
         },
         {
           code: 0,
           optionType: 103104,
           description: '午睡准备工作，备好床铺，拉好窗帘儿，营造安静睡眠环境。'
         }
       ]
     },
     {
       title: '其他',
       timeStr: '13:00-15:00',
       children: [
         {
           code: 0,
           optionType: 104101,
           description: '每天上午及下午打扫卫生，清洗厕所、水池。'
         },
         {
           code: 0,
           optionType: 104102,
           description:
            '每周四或五消毒玩具一次，每两周的周五整理幼儿被褥，交给老师让家长带回清洗。'
         },
         {
           code: 0,
           optionType: 104103,
           description: '每周一下午运动玩具、器具的清洁卫生和消毒，每周五进行图书晾晒'
         }
       ]
     }
   ];
  private series: any = [
    {
      name: '已消毒-合格',
      type: 'bar',
      stack: '记录',
      data: []
    },
    {
      name: '已消毒-不合格',
      type: 'bar',
      stack: '记录',
      data: []
    },
    {
      name: '已消毒-未复检',
      type: 'bar',
      stack: '记录',
      data: []
    },
    {
      name: '未消毒',
      type: 'bar',
      stack: '记录',
      data: []
    }
  ];
  private options: any = {
    color: ['#46AE84', '#7CB8F8', '#FF8A8A', '#FFD805', '#BD8DEF', '#70B603'],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    legend: {
      data: ['已消毒-合格', '已消毒-不合格', '已消毒-未复检', '未消毒']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        name: '日期',
        data: []
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '单位：班级'
      }
    ],
    series: []
  };

  @Watch('staticTime', {
    immediate: true,
    deep: true
  })
  onChangeValue(newVal: string[], oldValue: string[]) {
    this.staticForm.fromInspectTime = newVal.length ? newVal[0] : ''
    this.staticForm.toInspectTime = newVal.length ? newVal[1] : ''
  }
  @Watch('recordTime', {
    immediate: true,
    deep: true
  })
  onrecordTimeChangeValue(newVal: string[], oldValue: string[]) {
    this.recordForm.fromInspectTime = newVal.length ? newVal[0] : ''
    this.recordForm.toInspectTime = newVal.length ? newVal[1] : ''
  }

  created() {
    this.getStatic()
    this.getClassList()
  }
  /**
   * 获取班级
   */
  private async getClassList() {
    const resp = await classroomList({
      page: 1,
      size: 9999
    })
    this.classList = (resp as any).data.array || []
  }

  /**
   * 查看弹框列表
   */
  private async viewInfo(row: any) {
    this.infoVisible = true
    let Info = await disinfectCheckInfo({
      inspectRecordId: row.inspectRecordId
    })
    this.recordInfo = Info.data
    this.recordInfo.inspectRecordDetailVoList.map((item: any, index: any) => {
      let arr: any = this.initialData[index]
      item.childNodes.map((V: any, I: any) => {
        arr.children[I].code = V.isAbnormal
      })
      this.initialData[index] = arr
    })
  }

  /**
   * 导出详细数据
   */
  private async exportRecord() {
    let promise = null
    const resp = await disinfectCheckExport({
      ...this.recordForm
    })
    window.location = (resp as any).message
    return promise
  }

  /**
   * 柱状图
   */
  private getStatic() {
    disinfectCheckStatic({
      ...this.staticForm
    })
      .then(res => {
        console.log('>>>>', res)
        let arr = res.data.array || []
        arr = arr.reverse()
        if (arr.length === 0) {
          this.options.xAxis[0].data = []
          this.options.series = [];
          (this.$refs.staticChart as any).setOption(this.options)
          return
        }
        let xAxis: any = []
        this.series.map((item: any) => {
          item.data = []
        })
        let series = [...this.series]
        console.log(arr)
        arr.map((item: any, index: any) => {
          console.log(item.inspectTime)
          xAxis.push(this.$fn.parseTime(item.inspectTime, '{y}-{m}-{d}'))
          series[0].data.push(item.reInspectQualifiedSum)
          series[1].data.push(item.reInspectUnQualifiedSum)
          series[2].data.push(item.unReInspectRecordSum)
          series[3].data.push(item.unInspectRecordSum)
        })
        this.options.xAxis[0].data = xAxis
        this.options.series = [...series];
        (this.$refs.staticChart as any).setOption(this.options)
      })
      .catch(() => {})
  }
  /**
   * 统计查询
   */
  private staticSearch() {
    this.getStatic()
  }
  private staticReset() {
    this.staticForm.classroomIds = []
    this.getStatic()
  }
  /**
   * 记录
   */
  private recordSearch() {
    (this.$refs.table as any).search()
  }
  private recordReset() {
    Object.keys(this.recordForm).forEach(key => {
      this.recordForm[key] = ''
    })
    this.recordForm.fromInspectTime = this.recordTime[0]
    this.recordForm.toInspectTime = this.recordTime[1]
    this.$nextTick(() => {
      (this.$refs.table as any).search()
    })
  }
  private formaterInfo(row:any, index:any, key:any) {
    // let arr = this.initialData[index].children
    console.log(row)
    // let unList = row.comeGardenPrepareAbnormalList
    // console.log(unList)

    return row.classroomName
  }
  /**
   * 记录时间筛选
   */
  private getRecord() {
    this.recordSearch()
  }
}
